var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Hero"},[(_vm.src)?_c('div',{staticClass:"image"},[_c('Pic',{attrs:{"formats":_vm.formats,"src":_vm.src}})],1):_vm._e(),_c('div',{staticClass:"Hero-body"},[_c('Wrap',{staticClass:"lg"},[_vm._t("default")],2)],1),(_vm.$slots.outside)?_c('div',{staticClass:"outside"},[_vm._t("outside")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }